






























import Vue from "vue";
import EditRadioGroup from "@/components/end_parts/EditRadioGroup.vue";
import EditProjection from "@/components/end_parts/EditProjection.vue";
import projParam from "@/template/parameter/proj_param.json";
import { JsonObject } from "types/opts-json";

export default Vue.extend({
  components: {
    EditRadioGroup,
    EditProjection,
  },
  props: {
    optsParam: {
      type: Object,
      default: Object,
    },
    optsKey: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      JsonParam: "",
      ProjParam: {} as JsonObject,
      columnName: {
        "background-color": "#BAD3FF",
        padding: "10px",
        margin: "0px -15px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnCenter: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
      },
      column: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
    };
  },
  watch: {
    optsParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.JsonParam = this.optsParam[this.optsKey];
      this.ProjParam = projParam.public;
    },
    errorEvent(event: boolean) {
      this.$emit("hasError", event);
    },
    epsgEvent(event: string) {
      this.$emit("epsgConsole", event);
    },
  },
});
